import React from 'react'
import { IconPrimaryApp } from '@contrast-security-inc/design-system-foundations'
import { css } from '@emotion/css'

export const primaryApplicationIconTestId = 'primary-application-icon'

export function CsPrimaryApplicationIcon() {
  return <IconPrimaryApp size="sm" testId={primaryApplicationIconTestId} />
}

export function ClickablePrimaryApplicationIcon(props) {
  return (
    <span
      {...props}
      className={css`
        cursor: pointer;
        padding-top: 6px;
        line-height: 1.42857;
      `}
    >
      <IconPrimaryApp size="sm" testId="clickable-primary-application-icon" />
    </span>
  )
}
